import { render, staticRenderFns } from "./DatasetUIWrapper.vue?vue&type=template&id=6def6ce4&"
import script from "./DatasetUIWrapper.vue?vue&type=script&lang=js&"
export * from "./DatasetUIWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports